var unirest = require('unirest');
const API = require ('Api') ;

export async function getCourseEvaluations ( token, courseID ) {
    const res =  await unirest.get(API.V2 + API.EVALUATIONS + courseID  )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function getTeachers ( token, srchQry ) {
    const res =  await unirest.get(API.V2  + 'teachers/search/'+srchQry  )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}





export async function unEnrollTeacher( token, courseID, courseSubjectID, personaID ) {
    const res =  await unirest.delete(API.V2  + 'courses/'+ courseID + '/subjects/'+courseSubjectID+'/teachers/'+ personaID)
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) {
        console.log(res.error)
    }
    return res.body ; 
}   


export async function enrollTeacher( token, courseID, courseSubjectID, data) {
    const res =  await unirest.post(API.V2  + 'courses/'+ courseID + '/subjects/' + courseSubjectID + '/teachers'  )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    .send(data)

    if (res.error) {
        console.log(res.error)      
    }
    return res.body ;    
}

export async function unEnroleSubject( token, courseID, courseSubjectID) {
    const res =  await unirest.delete(API.V2  + 'courses/'+ courseID + '/subjects/' + courseSubjectID )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})

    if (res.error) {
        console.log(res.error)      
    }
    return res.body ;    
}

export async function enrollSubject( token, courseID, courseSubjectID) {
    const res =  await unirest.post(API.V2  + 'courses/'+ courseID + '/subjects/' + courseSubjectID )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})

    if (res.error) {
        console.log(res.error)      
    }
    return res.body ;    
}


export async function scheduleClasss( token, courseID, courseSubjectID, data) {
    const res =  await unirest.post(API.V2  + 'courses/'+ courseID + '/subjects/' + courseSubjectID + '/schedule'  )
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    .send(data)

    if (res.error) {
        console.log(res.error)      
    }
    return res.body ;    
}

export async function unScheduleClass( token, courseID, courseSubjectID, courseSubjectScheduleID ) {
    const res =  await unirest.delete(API.V2  + 'courses/'+ courseID + '/subjects/'+courseSubjectID+'/schedule/'+ courseSubjectScheduleID)
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) {
        console.log(res.error)
    }
    return res.body ; 
}   


export async function getCourseTutors ( token, courseID ) {
    const res =  await unirest.get(API.V2  + 'tutors/'+ courseID  )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getTutors ( token ) {
    const res =  await unirest.get(API.V2  + 'tutors'  )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}



export async function unEnroleTutor( token, courseID, personaID ) {
    const res =  await unirest.delete(API.V2  + 'courses/'+ courseID + '/tutors/'+personaID)
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) {
        console.log(res.error)
        
    }
    return res.body ; 
}

export async function enroleTutor( token, courseID, calendarID, personaID ) {
    const data = { persona_id: personaID }
    const res =  await unirest.post(API.V2  + 'courses/'+ courseID + '/tutors')
    .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    .send(data)
    if (res.error) {
        console.log(res.error)
        
    }
    let ret = res.body ;

    if (ret.persona_id === personaID ) {
        const tutor =  await getPersona ( token, personaID );
        return tutor ;
    } else {
        return null ;
    }
    
}

export async function getPersona ( token, personaID ) {
    const res =  await unirest.get(API.V2 + API.PERSONAS  + personaID )
            .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
return res.body ;
}



export async function unEnroleStudent( token, courseID, personaID ) {
    const res =  await unirest.delete(API.V2  + 'courses/'+ courseID + '/students/'+personaID)
    .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) {
        console.log(res.error)
        
    }
    return res.body ; 
}

export async function enroleStudent( token, courseID, calendarID, personaID ) {
    const data = { persona_id: personaID }
    const res =  await unirest.post(API.V2  + 'courses/'+ courseID + '/students')
    .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    .send(data)
    if (res.error) {
        console.log(res.error)
        
    }
    let ret = res.body ;
    if (ret.persona_id === personaID ) {
        const student =  await getStudentBrief ( token, personaID , calendarID);
        return student ;
    } else {
        return null ;
    }
    
}

export async function getUnenroledSubjects ( token, courseID ) {
    const res =  await unirest.get(API.V2 + API.COURSES  + courseID + "/unenroledsubjects")
            .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    
    let subjects = res.body ;
return subjects ;
}


export async function getSubjects ( token, courseID ) {
    const res =  await unirest.get(API.V2 + API.COURSES  + courseID + "/subjects")
            .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let subjects = res.body ;
return subjects ;
}

export async function getStudentBrief ( token, personaID , calendarID) {
    const res =  await unirest.get(API.V1 + 'students/'  + personaID + "/brief" )
            .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let brief = res.body ;
return brief ;
}


export async function getUnroledStudents ( token, calendarID, srchQry ) {
    const res =  await unirest.get(API.V2  + 'students/unenroled/'+srchQry  )
            .headers({'Authorization': 'Bearer ' + token, 
            'crrntcal':calendarID });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getStudentCourseHistory ( token, studentID ) {
    const res =  await unirest.get(API.V2  + 'students/' + studentID + '/course/history'  )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error) 
    let list = res.body ;
return list ;
}

export async function getSchoolCourse ( token, courseID, calendarID) {
    const res =  await unirest.get(API.V2 + API.COURSES  + courseID + "/brief" )
            .headers({'Authorization': 'Bearer ' + token, 
            'crrntcal':calendarID })
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseQualifications ( token, courseID ) {
    const res =  await unirest.get(API.V2  + API.QUALIF  + courseID  )
            .headers({'Authorization': 'Bearer ' + token})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseTeachers ( token, courseID ) {
    const res =  await unirest.get(API.V2  + API.COURSES  + courseID + '/teachers'  )
            .headers({'Authorization': 'Bearer ' + token})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getCourseSubjectsEvalsBrief ( token, courseID ) {
    const res =  await unirest.get(API.V2  + API.EVALUATIONS  + courseID  + "/brief" )
            .headers({'Authorization': 'Bearer ' + token})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
} 